const PasswordView = () => null;
export default PasswordView;
